module.exports = __webpack_public_path__ + "src/components/Ranktable/icon-increase.png?4fdbf407";


//////////////////
// WEBPACK FOOTER
// ./src/components/Ranktable/icon-increase.png
// module id = 2817
// module chunks = 1